import keybefore from './keybefore';
import keyafter from './keyafter';
// Stu@den t#128 !xw#

// Stu@den t#128 !xw#
export default keybefore + 't#128' + keyafter;
